define('AddCoreFee', [
	'Cart.Item.Actions.View',
	'Cart.Item.Summary.View',
	'AddCoreFee.View',
	
  'apcocart_item_actions.tpl',
	'apcocart_item_summary.tpl',
	
  'underscore',
], function (
  CartItemsActionsView,
  CartItemSummaryView,
  AddCoreFeeView,

	apcocart_item_actions_tpl,
	apcocart_item_summary_tpl,
  _
) {
	'use strict';

  function getCoreFeeParentItem(self) {

    return _.find(self.model.collection.models, function(currentModel) {
      return currentModel.get('item').get('custitem_apco_core_fee_item_id') === self.model.get('item').get('internalid');
    });


  }

	return {
		mountToApp: function mountToApp(container) {
			if (!SC.isPageGenerator()) {

				var cart = container.getComponent('Cart');
				var pdp = container.getComponent('PDP');
				var plp = container.getComponent('PLP');
				var layout = container.getComponent('Layout');

				if (cart) {
					try {
						CartItemSummaryView.prototype.getContext = _.wrap(
							CartItemSummaryView.prototype.getContext,
							function (fn) {
								var context = fn.apply(this, _.toArray(arguments).slice(1));
                var self = this;
                
                var coreFeeParentItem = getCoreFeeParentItem(self);
                var coreFeeParentName = !!coreFeeParentItem ? coreFeeParentItem.get('item').get('_name') : '';

                return _.extend(context, {
                  isCoreFeeItem: !!coreFeeParentItem,
                  coreFeeParentName: coreFeeParentName
                });
							}
						);

            CartItemSummaryView.prototype.template = apcocart_item_summary_tpl;

						CartItemsActionsView.prototype.template = apcocart_item_actions_tpl;

						CartItemsActionsView.prototype.getContext = _.wrap(
							CartItemsActionsView.prototype.getContext,
							function (fn) {
								var context = fn.apply(this, _.toArray(arguments).slice(1));
                var self = this;                
                var coreFeeParentItem = getCoreFeeParentItem(self);

                return _.extend(context, {
                  showItemActions: !!!coreFeeParentItem
                })
							}
						);


					} catch (e) {
						console.error(e);
					}
				}

				if (pdp) {
					try {
						pdp.on('beforeShowContent', function () {
							var itemInfo = pdp.getItemInfo();
							var coreFeeFormatted =
								itemInfo.item.custitem_apco_core_deposit_formatted || '';
							var coreFee = itemInfo.item.custitem_apco_core_deposit || 0.0;

							if (coreFeeFormatted) {
								pdp.addChildViews(pdp.PDP_FULL_VIEW, {
									'Product.Price': {
										CoreFeeView: {
											childViewIndex: 1000,
											childViewConstructor: function () {
												return new AddCoreFeeView({
													application: container,
													core_fee_formatted: coreFeeFormatted,
													core_fee: coreFee,
												});
											},
										},
									},
								});

								pdp.addChildViews(pdp.PDP_QUICK_VIEW, {
									'Product.Price': {
										CoreFeeView: {
											childViewIndex: 1000,
											childViewConstructor: function () {
												return new AddCoreFeeView({
													application: container,
													core_fee_formatted: coreFeeFormatted,
													core_fee: coreFee,
												});
											},
										},
									},
								});
							}
						});
					} catch (e) {
						console.error(e);
					}
				}

				if (layout && plp) {
					plp.on('beforeShowContent', function () {
						layout.addToViewContextDefinition(
							'Cart.QuickAddToCart.View',
							'core_fee_formatted_2',
							'string',
							function core_fee_formatted_2(context) {
								var itemsInfo = plp.getItemsInfo();
								if (itemsInfo) {
									var model = _.find(itemsInfo, function (item) {
										return item.internalid == context.itemId;
									});

									if (model && model.custitem_apco_core_deposit_formatted) {
										coreFeeFormatted =
											model.custitem_apco_core_deposit_formatted;
										coreFee = model.custitem_apco_core_deposit;

										layout.addChildViews(plp.PLP_VIEW, {
											'ProductViewsPrice.Price': {
												CoreFeeView: {
													childViewIndex: 1000,
													childViewConstructor: function () {
														return new AddCoreFeeView({
															application: container,
															core_fee_formatted: coreFeeFormatted,
															core_fee: coreFee,
														});
													},
												},
											},
										});
									}
								}
							}
						);
					});
					plp.on('afterShowContent', function () {
						layout.removeToViewContextDefinition(
							'Cart.QuickAddToCart.View',
							'core_fee_formatted_2'
						);
					});
				}
			}
		},
	};
});
